module.exports = __webpack_public_path__ + "img/chpc_index_honor6.a9396312.png";